import { IAuthState, UserTypes, IAuth } from "src/modules/Auth/store/types";

export const sessionTime = (state: IAuthState | IAuth) => {
  if (state.userType !== UserTypes.UNAUTH && state.idToken) {
    const expirationTime = state.idToken.payload.exp;
    const currentTime = new Date().getTime();
    const timeLeft = (expirationTime * 1000 - currentTime) - (1000 * 60 * 2);
    return { isAuthenticated: true, isExpired: timeLeft < 0, timeLeft };
  }
  return { isAuthenticated: false, isExpired: false, timeLeft: 0 }
}